// Sanitizes a display name supplied by an auth provider (Sign in with Apple,
// Google) into a value the onboarding flow can store as users/{uid}/name.
//
// Deliberately MUCH more lenient than the wizard's typed-input validator:
// App Store Guideline 4 forbids making the user re-enter (or correct) a name
// the provider already supplied, so a real name like "Liam O'Connor" must be
// accepted as-is even though the typed-name regex would reject it. The typed
// path keeps its own strict rule in OnboardingWizard.isValidName.
const MAX_NAME_LENGTH = 30;

export const sanitizeProviderName = (raw) => {
  if (typeof raw !== "string") return "";
  // Control/format characters (\p{C}) can't be part of a human name; the
  // whitespace collapse below swallows the replacement blanks.
  const cleaned = raw
    .replace(/\p{C}/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
  // A name with no letter in any script is not a usable name — fall back to
  // asking (never plausible from a real Apple/Google profile).
  if (!/\p{L}/u.test(cleaned)) return "";
  if (cleaned.length <= MAX_NAME_LENGTH) return cleaned;
  // Too long for the product's name cap: keep the first token that actually
  // contains a letter (a leading numeric/symbol token must not shadow the
  // name), clamped. A clamped name still addresses the learner; a rejection
  // would re-open the prompt Apple told us to remove.
  const token = cleaned.split(" ").find((part) => /\p{L}/u.test(part));
  return token.slice(0, MAX_NAME_LENGTH);
};
